import React from "react";
import Chart from "react-apexcharts";

function LineChart({
  data,
  resheight = 300,
  height,
  labelx = false,
  labely = false,
  icon = "₼",
}) {
  const series = [
    {
      name: "Balans",
      data: data,
    },
  ];
  const options = {
    responsive: [
      {
        breakpoint: 526,
        options: {
          chart: {
            height: resheight,
          },
          yaxis: {
            show: false,
          },
        },
      },
    ],
    chart: {
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      labels: {
        show: labelx,
        rotate: 0,
      },
    },
    yaxis: {
      labels: {
        formatter: value => {
          return (
            value.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + icon
          );
        },
        show: labely,
      },
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="line"
      width="100%"
      height={height}
    />
  );
}

export default LineChart;
